import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faMinusSquare } from '@fortawesome/free-solid-svg-icons';
import useUserRoles from '../../hooks/useUserRoles';
import { useDispatch } from '../../redux/store';
import { setDialogMode, openDialog, selectDeliveryLocation } from '../../redux/slices/deliveryLocation';
import type { ICellRendererParams } from 'ag-grid-community';
import type { DeliveryLocationType } from '../../types/deliveryLocation';

const ActionsManageDeliveryLocation = (props: ICellRendererParams) => {
  const dispatch = useDispatch();
  const { isMaintenanceadmin } = useUserRoles();
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isDeletable, setIsDeletable] = useState<boolean>(false);
  const data: DeliveryLocationType = props.data;

  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log(data);
  // }, []);

  // 保守アドミンなら編集可能な状態にする
  useEffect(() => {
    if (isMaintenanceadmin) {
      setIsEditable(true);
      setIsDeletable(true);
    }
  }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * Editボタンを押した時
   */
  const handleUpdateRow = (): void => {
    // console.log(props)
    if (isEditable) {
      dispatch(selectDeliveryLocation(data));
      dispatch(setDialogMode('UPDATE'));
      dispatch(openDialog());
    }
  };

  /**
   * Deleteボタンを押した時
   */
  const handleDeleteRow = (): void => {
    // console.log(props)
    if (isDeletable) {
      dispatch(selectDeliveryLocation(data));
      dispatch(setDialogMode('DELETE'));
      dispatch(openDialog());
    }
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <div id="editActions">
        <>
          <FontAwesomeIcon
            className="mr-3"
            icon={faEdit}
            size="lg"
            color={isEditable ? '#007bff' : '#ccc'}
            onClick={handleUpdateRow}
            style={isEditable ? { cursor: 'pointer' } : { cursor: 'default' }}
          />
          <FontAwesomeIcon icon={faMinusSquare} size="lg" color={isDeletable ? '#c4183c' : '#ccc'} onClick={handleDeleteRow} style={isDeletable ? { cursor: 'pointer' } : { cursor: 'default' }} />
        </>
      </div>
    </>
  );
};

export default ActionsManageDeliveryLocation;
